<template>
<div class="main-container">
  <Navbar :user="user" v-if="user && user.role" />
  <main class="app-main">
    <router-view></router-view>
  </main>
</div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';

export default {
  data: () => ({
    user: null,
  }),
  components: {
    Navbar,
    // Footer,
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem('user'));
  },
};
</script>

<style>
@media screen {
  .product-list, .product-list * {
    visibility: hidden;
  }
}
@media print {
  /* Hide everything */
  body * {
    visibility: hidden;
  }

  /* Then display only the product list and its children */
  .product-list, .product-list * {
    visibility: visible;
  }

  /* Adjust the position to be printable */
  .product-list {
    position: absolute;
    left: 0;
    top: 0;
  }
}

html, body {
  position: relative;
}

.main-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  color: var(--text);
}

/* Full-width content area with sane gutters: uses the whole screen on
   desktops instead of the old centered fixed-width container. */
.app-main {
  flex: 1 1 auto;
  width: 100%;
  max-width: 1800px;
  margin: 0 auto;
  padding: 0 clamp(16px, 2.2vw, 40px) 56px;
}
</style>
